<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>
      Quote details
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Purpose</mat-label>
          <mat-select placeholder="Purpose" formControlName="purpose" (selectionChange)="updateSelectedPurpose($event.value)">
            <mat-option *ngFor="let purpose of loanPurposes" [value]="purpose.id">{{purpose.text}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'purpose'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-3" *ngIf="showCarSearch">
        <fmc-car-search
          [placeholderText]="'Car search'"
          [parentFormGroup]="formGroup"
          [controlName]="'vehicle'"
        ></fmc-car-search>
      </div>
      <!-- disabled temporarily until VIN search is fixed-->
      <div class="col-sm-3" *ngIf="showHistorySearch">
        <mat-form-field appearance="outline">
          <mat-label>Search VIN or chassis number</mat-label>
          <input matInput placeholder="Search VIN or chassis number" formControlName="vin">
          <button color="primary" type="button" mat-icon-button matSuffix class="fmc-button-primary" (click)="searchVin()">
            <mat-icon>search</mat-icon>
          </button>
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'vin'"></app-validation-partial>
          </mat-error>
        </mat-form-field>
        <mat-error>
          <app-validation-partial [formGroup]="formGroup" [fieldName]="'vin'"></app-validation-partial>
        </mat-error>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Purchase / Refinance amount (inc GST)</mat-label>
          <input matInput placeholder="Purchase / Refinance amount (inc GST)" type="number" formControlName="purchaseRefinanceAmount">
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'purchaseRefinanceAmount'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-7" *ngIf="!showHistorySearch">
        <div class="row">
          <div class="col-sm-10">
            <mat-form-field appearance="outline">
              <mat-label class="mb-0" style="color: rgba(0, 0, 0, 0.54);"><small>Variant</small></mat-label>
              <select matNativeControl class="full-select" formControlName="variant" (change)="getVariantSpecs($event.target)">
                <option *ngIf="!variantTypes  || variantTypes.length === 0" selected [value]="null">Select Model to show variant</option>
                <option *ngIf="variantTypes.length > 0" selected [value]="null">Select Variant</option>
                <option *ngFor="let type of variantTypes" [value]="type.nvic">
                  [{{type.nvic}}] {{type.name}}
                </option>
              </select>
            </mat-form-field>
          </div>
          <p *ngIf="isGreen" class="col-sm-2 d-flex align-items-center justify-content-center text-success"><i class="material-icons">eco</i> <i>green vehicle</i></p>
        </div>
      </div>

      <div class="col-sm-4" *ngIf="showHistorySearch">
          <fmc-car-search
            [placeholderText]="'Car search'"
            [parentFormGroup]="formGroup"
            [controlName]="'vehicle'"
          ></fmc-car-search>
      </div>
      <div class="col-sm-3" *ngIf="showHistorySearch">
        <mat-form-field appearance="outline">
          <mat-label>Odometer</mat-label>
          <input matInput placeholder="Odometer" type="number" formControlName="odometer">
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Deposit / trade amount</mat-label>
          <input matInput placeholder="Deposit / trade amount" type="number" formControlName="depositTradeAmount">
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'depositTradeAmount'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-7">
        <div class="row" *ngIf="showHistorySearch">
          <div class="col-sm-10">
            <mat-form-field appearance="outline">
              <mat-label class="mb-0" style="color: rgba(0, 0, 0, 0.54);"><small>Variant</small></mat-label>
              <select matNativeControl class="full-select" placeholder="Variant" formControlName="variant" (change)="getVariantSpecs($event.target)">
                <option *ngIf="!variantTypes  || variantTypes.length === 0" selected [value]="null">Select Model to show variant</option>
                <option *ngIf="variantTypes.length > 0" selected [value]="null">Select Variant</option>
                <option *ngFor="let type of variantTypes" [value]="type.nvic">
                  [{{type.nvic}}] {{type.name}}
                </option>
              </select>
            </mat-form-field>
          </div>
          <p *ngIf="isGreen" class="col-sm-2 d-flex align-items-center justify-content-center text-success"><i class="material-icons">eco</i> <i>green vehicle</i></p>
        </div>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Subtotal</mat-label>
          <input matInput placeholder="Subtotal" type="number" formControlName="subTotal" readonly>
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'subTotal'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-sm-3 d-flex justify-content-end">
        <mat-checkbox formControlName="originationFeeCheck" class="d-flex" (change)="toggleOriginatorFee($event.checked)">No origination fee</mat-checkbox>
        <mat-error>
          <app-validation-partial
            [formGroup]="formGroup"
            [fieldName]="'originationFeeCheck'"
          ></app-validation-partial>
        </mat-error>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Origination fee (inc GST)</mat-label>
          <input matInput placeholder="Origination fee (inc GST)" type="number" formControlName="originationFee">
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'originationFee'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div  class="col-sm-7"></div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Application fee</mat-label>
          <input matInput placeholder="Application fee" type="number" formControlName="applicationFee" readonly>
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'applicationFee'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Insurances -->
    <div class="row" *ngFor="let insurance of insurancesFormArray.controls; let i=index" [formGroup]="insurance">
      <div class="col-sm-3 offset-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Select an insurance</mat-label>
          <mat-select placeholder="Select an insurance" formControlName="insuranceId" (selectionChange)="processInsurances()">
            <mat-option *ngFor="let insurance of insurancePurposes" [value]="insurance.id">{{insurance.text}}</mat-option>
          </mat-select>
          <mat-error>
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Insurance / Warranty amount (inc GST)</mat-label>
          <input matInput placeholder="Insurance / Warranty amount (inc GST)" type="number" formControlName="insuranceAmount" (change)="processInsurances()">
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            Must be greater than supplied value
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-1">
        <button type="button" mat-icon-button (click)="removeInsurance(i)" color="warn"><mat-icon>remove_circle</mat-icon></button>
        <button type="button" mat-icon-button (click)="addInsurance(i)" color="primary" *ngIf="i === insurancesFormArray.controls.length - 1"><mat-icon>add_circle_outline</mat-icon></button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-7"></div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Subtotal + fees</mat-label>
          <input matInput placeholder="Subtotal + fees" type="number" formControlName="subtotalWithFees" readonly>
          <span matPrefix>$&nbsp;</span>
          <mat-error style="font-size: xx-small">
            Insurances must not reach 10% of purchase price
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-0 col-md-2"></div>
      <div class="col-sm-4 col-md-2 d-flex flex-column justify-content-end">
        <!-- Dial Down Enabled - {{dialDownEnabled}} -->
        <mat-checkbox formControlName="brokerageFeeCapitalizedCheck" (change)="toggleDialDown($event.checked)">Capitalise brokerage</mat-checkbox>
        <mat-checkbox formControlName="brokerageFeeCheck" (change)="toggleBrokerageFees($event.checked)">No brokerage fee</mat-checkbox>
        <mat-error>
          <app-validation-partial
            [formGroup]="formGroup"
            [fieldName]="'brokerageFeeCheck'"
          ></app-validation-partial>
        </mat-error>
      </div>
      <div class="col-sm-3">
        <mat-form-field appearance="outline">
          <mat-label>Brokerage percent (inc GST)</mat-label>
          <input matInput placeholder="Brokerage percent (inc GST)" type="number" formControlName="brokerageFeePercentage" ng-model='val | number: 2'>
          <span matSuffix>%</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'brokerageFeePercentage'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Brokerage amount (inc GST)</mat-label>
          <input matInput placeholder="Brokerage amount (inc GST)" type="number" formControlName="brokerageFee">
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'brokerageFee'"
            ></app-validation-partial>
            <span *ngIf="formGroup.get('brokerageFee')?.errors?.max">&nbsp;- Max brokerage amount: ${{rateData.MaxBrokerageAmountAvailable}}</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 offset-sm-7">
        <mat-form-field appearance="outline">
          <mat-label>Total loan amount</mat-label>
          <input matInput placeholder="Total loan amount" type="number" formControlName="totalLoanAmount" readonly>
          <span matPrefix>$&nbsp;</span>
          <mat-error>
            <ng-container *ngIf="(formGroup.get('totalLoanAmount')?.invalid && (formGroup.get('totalLoanAmount')?.dirty || formGroup.get('totalLoanAmount')?.touched))  || (formGroup.get('totalLoanAmount')?.errors)">

              <span *ngIf="formGroup.get('totalLoanAmount')?.errors?.required">This field is required</span>

              <ng-container *ngIf="!formGroup.get('totalLoanAmount')?.errors?.required">

                <span *ngIf="formGroup.get('totalLoanAmount')?.errors.min">Must be greater than supplied value</span>

                <span *ngIf="formGroup.get('totalLoanAmount')?.errors.max">
                  Maximum Loan Amount should be ${{formGroup.get('totalLoanAmount')?.errors.max.max}}
                </span>

              </ng-container>
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-7"></div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Select repayment</mat-label>
          <mat-select placeholder="Select repayment" formControlName="repaymentFrequency">
            <mat-option *ngFor="let repayment of repaymentTypes" [value]="repayment.id">{{repayment.text}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'repaymentFrequency'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-7"></div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Select loan term</mat-label>
          <mat-select placeholder="Select loan term" formControlName="loanTermId" (selectionChange)="updateTerm($event.value)" [disabled]="!enableLoanTerms">
            <mat-option *ngFor="let term of loanTerms" [value]="term.slug">{{term.name}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'loanTermId'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-3">
          <mat-form-field appearance="outline">
            <mat-label>Select balloon percentage</mat-label>
            <mat-select placeholder="Select balloon percentage" formControlName="balloonPercentage" [disabled]="disableBalloons || vehicleAge > 4" (selectionChange)="calculateBalloon()">
              <mat-option *ngFor="let balloon of allBalloons" [value]="balloon">{{balloon}} %</mat-option>
            </mat-select>
            <mat-error>
              <app-validation-partial [formGroup]="formGroup" [fieldName]="'balloonPercentage'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field appearance="outline">
            <mat-label>Balloon amount</mat-label>
            <input matInput placeholder="Balloon amount" type="number" formControlName="balloonAmount" [readonly]="disableBalloons || vehicleAge > 4">
            <span matPrefix>$&nbsp;</span>
            <mat-error>
              <app-validation-partial [formGroup]="formGroup" [fieldName]="'balloonAmount'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="vehicleAge > 4">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <small>Balloon not available for vehicles more than 4 years old</small>
        </div>
      </div>
    <div class="row" *ngIf="loanTermInYears > 5">
      <div class="col-sm-4"></div>
      <div class="col-sm-8">
        <small>Balloon payment is not permitted for loans with a term greater than 5 years.</small>
      </div>
    </div>
  </mat-card-content>
</mat-card>
